"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefreshIcon = exports.RefreshButton = exports.CloudinaryPictureWithControls = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _helpers = require("../../styles/helpers");
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//components

var CloudinaryPictureWithControls = exports.CloudinaryPictureWithControls = _styledComponents["default"].div.withConfig({
  displayName: "styles__CloudinaryPictureWithControls",
  componentId: "sc-1tej23x-0"
})(["height:100%;position:relative;width:100%;&:not(:hover){", "{display:none;}}"], function () {
  return RefreshButton;
});
var RefreshButton = exports.RefreshButton = _styledComponents["default"].div.withConfig({
  displayName: "styles__RefreshButton",
  componentId: "sc-1tej23x-1"
})(["", ";background:#fff;border-radius:50%;cursor:pointer;height:57px;opacity:0.9;width:57px;"], _helpers.center);
var RefreshIcon = exports.RefreshIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'refresh'
}).withConfig({
  displayName: "styles__RefreshIcon",
  componentId: "sc-1tej23x-2"
})(["", ";"], _helpers.center);
//# sourceMappingURL=styles.js.map